import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'game-menu',
    templateUrl: './game-menu.component.html',
    styleUrls: ['./game-menu.component.scss'],
    standalone: false
})
export class GameMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input() game;

  window:any = (<any>window);
}
